import { inboundUnitCipher } from "@src/context/UnitsContext";
import { useQuery as useReactQuery } from "@tanstack/react-query";
import FetchClients, { ClientOutput } from "../client";

export type UtilityUnitConversion =
  ClientOutput["units"]["UtilityUnitConversion"];

const units = {
  useQueryMap,
  useQueryConversion,
} as const;

export default units;

// Deliberately not access-checked: UnitsContextProvider calls these at the app root,
// outside every FeatureAccessContextProvider, so a "Utilities" check would warn on every page load.
const UNITS_KEY = "units";
// Gets units, filters out units that don't have a defined mapping, and maps the db units to valinor units
function useQueryMap() {
  return useReactQuery({
    queryKey: [UNITS_KEY],
    queryFn: () => FetchClients.units.GET("").then((res) => res.data),
    select: (data) => {
      if (!data) {
        return {};
      }
      return Object.fromEntries(
        data!.map(
          (unit) =>
            [
              unit.id,
              {
                id: unit.id,
                key: unit.name,
                label: inboundUnitCipher[unit.name],
              },
            ] as const
        )
      );
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

const UNITS_CONVERSION_KEY = "units-conversion";
function useQueryConversion() {
  return useReactQuery({
    queryKey: [UNITS_CONVERSION_KEY],
    queryFn: () =>
      FetchClients.units
        .GET("/conversion")
        .then((res) => res.data as UtilityUnitConversion[]),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
